import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'LeadForm',
})(({ brandColors, spacing, breakpoints, type, typography }, props) => ({
  textInputRow: {
    marginBottom: spacing(1),
    '&:last-child': {
      marginBottom: spacing(2),
    },
    '& > *:first-child:not(:last-child)': {
      marginBottom: spacing(1),
    },
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('sm')]: {
      '& > *:first-child:not(:last-child)': {
        marginBottom: 0,
      },
      flexDirection: 'row',
      '& > *:not(:last-child)': {
        marginRight: spacing(1),
      },
    },
  },
  textInputRowEvenSpacing: {
    marginBottom: spacing(1),
    '& > *:first-child:not(:last-child)': {
      marginBottom: spacing(1),
    },
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('sm')]: {
      '& > *:first-child:not(:last-child)': {
        marginBottom: 0,
      },
      flexDirection: 'row',
      '& > *:not(:last-child)': {
        marginRight: spacing(1),
      },
    },
  },
  form: {
    backgroundColor: brandColors.tintsOffWhite60,
    borderRadius: typography.pxToRem(24),
    boxShadow: `0px 39.25334px 39.25334px 0px rgba(0, 0, 0, 0.08)`,
    padding: `${spacing(3)} ${typography.pxToRem(24)}`,
    [breakpoints.up('sm')]: {
      paddingLeft: typography.pxToRem(40),
      paddingRight: typography.pxToRem(40),
    },
    [breakpoints.up('lg')]: {
      paddingLeft: typography.pxToRem(80),
      paddingRight: typography.pxToRem(80),
    },
  },
  formHero: {
    backgroundColor: brandColors.tintsOffWhite60,
    borderRadius: typography.pxToRem(24),
    boxShadow: `0px 39.25334px 39.25334px 0px rgba(0, 0, 0, 0.08)`,
    padding: spacing(2),
  },
  formHeading: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    marginBottom: spacing(0),
  },
  formSubHeading: {
    color: darkOrLightStyle(props)(
      brandColors.white,
      brandColors.tintsNeutral20
    ),
  },
  formContent: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    marginTop: spacing(1),
  },
  radioGroup: {
    marginBottom: `${spacing(2)}!important`,
  },
  radioGroupHero: {
    marginBottom: `${spacing(1)}!important`,
    fontSize: typography.pxToRem(50),
  },
  tcpa: {
    '& p, a': {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20,
        true
      ),
      fontSize: `${type['12_regular'].fontSize}!important`,
      fontWeight: `${type['12_regular'].fontWeight}!important`,
      lineHeight: `${type['12_regular'].lineHeight}!important`,
      letterSpacing: `${type['12_regular'].letterSpacing}!important`,
      marginBottom: spacing(2),
    },
    [breakpoints.up('sm')]: {
      '& p, a': {
        fontSize: `${type['14_regular'].fontSize}!important`,
        fontWeight: `${type['14_regular'].fontWeight}!important`,
        lineHeight: `${type['14_regular'].lineHeight}!important`,
        letterSpacing: `${type['14_regular'].letterSpacing}!important`,
      },
    },
    [breakpoints.up('lg')]: {
      '& p, a': {
        fontSize: `${type['16_regular'].fontSize}!important`,
        fontWeight: `${type['16_regular'].fontWeight}!important`,
        lineHeight: `${type['16_regular'].lineHeight}!important`,
        letterSpacing: `${type['16_regular'].letterSpacing}!important`,
      },
    },
  },
  tcpaHero: {
    '& p, a': {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20,
        true
      ),
      fontSize: `${type['12_regular'].fontSize}!important`,
      fontWeight: `${type['12_regular'].fontWeight}!important`,
      lineHeight: `${type['12_regular'].lineHeight}!important`,
      letterSpacing: `${type['12_regular'].letterSpacing}!important`,
      marginBottom: spacing(1),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  submitError: {
    color: brandColors.errorMain,
    ...type['14_medium'],
    marginBottom: spacing(0),
  },
  button: {
    minWidth: typography.pxToRem(224),
    [breakpoints.up('sm')]: {
      minWidth: typography.pxToRem(278),
    },
  },
  leadSubmittedText: {
    color: brandColors.primaryMain,
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    flexBasis: '100%',
  },
  horizontalButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.up('sm')]: {
      justifyContent: 'start',
    },
  },
  horizontalButton: {
    display: 'flex',
    justifyContent: 'center',
    minWidth: typography.pxToRem(278),
    padding: `${typography.pxToRem(18)} ${typography.pxToRem(24)}`,
    [breakpoints.up('sm')]: {
      padding: `${typography.pxToRem(18)} ${spacing(2)}`,
    },
    [breakpoints.up('lg')]: {
      padding: `${typography.pxToRem(18)} ${spacing(1)}`,
    },
  },
  buttonHero: {
    width: '100%',
  },
  homeQuestionHeading: {
    paddingTop: typography.pxToRem(24),
    marginBottom: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
}));

export default useStyles;
